import * as actionKeys from './action-keys';
import { updateObject } from './utility';

const DEFAULT_STATE = {
    resources: {
        errorHeader: 'Der opstod en fejl',
        errorTitle: 'Der opstod en fejl',
        errorDescription: 'Du kan prøve igen eller kontakte os, hvis problemet fortsætter.',
        errorBackText: 'Tilbage',
        errorContactLink: 'https://www.topdanmark.dk/faa-hjaelp/kontakt-os/',
        errorContactText: 'Kontakt os'
    },
    uiStatus: 'loading',
    displayError: false,
    formStep: 1,
    isSubmitting: false,
    errorText: '',
    submitEndpoint: '',
    receiptEndpoint: '',
    openTimesEndpoint: '',
    postFormData: '',
    flow: '',
    showInsurances: false,
    openingTimes: '',
    submitGenesysEndpoint: '',
    submitInsuranceGuideEndpoint: ''
};

const uiReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case actionKeys.SET_RESOURCES:
            return updateObject(state, { resources: action.payload });

        case actionKeys.SET_UI_STATUS:
            return updateObject(state, { uiStatus: action.payload });

        case actionKeys.SET_DISPLAY_ERROR:
            return updateObject(state, { displayError: action.payload });

        case actionKeys.SET_FORM_STEP:
            return updateObject(state, { formStep: action.payload });

        case actionKeys.SET_IS_SUBMITTING:
            return updateObject(state, { isSubmitting: action.payload });

        case actionKeys.SET_ERROR_TEXT:
            return updateObject(state, { errorText: action.payload });

        case actionKeys.SET_SUBMIT_ENDPOINT:
            return updateObject(state, { submitEndpoint: action.payload });

        case actionKeys.SET_RECEIPT_ENDPOINT:
            return updateObject(state, { receiptEndpoint: action.payload });

        case actionKeys.SET_POST_FORM:
            return updateObject(state, { postFormData: action.payload });

        case actionKeys.SET_FLOW: {
            return updateObject(state, { flow: action.payload });
        }

        case actionKeys.SET_SHOW_INSURANCES: {
            return updateObject(state, { showInsurances: action.payload });
        }

        case actionKeys.SET_OPEN_TIMES_ENDPOINT: {
            return updateObject(state, { openTimesEndpoint: action.payload });
        }

        case actionKeys.SET_OPENING_TIMES: {
            return updateObject(state, { openingTimes: action.payload });
        }

        case actionKeys.SET_SUBMIT_GENESYS_ENDPOINT: {
            return updateObject(state, { submitGenesysEndpoint: action.payload });
        }

        case actionKeys.SET_SUBMIT_INSURANCE_GUIDE_ENDPOINT: {
            return updateObject(state, { submitInsuranceGuideEndpoint: action.payload });
        }

        default:
            return state;
    }
};

export default uiReducer;
